import { useLocalizedText } from 'src/shared/utils/use-localized-text/useLocalizedText'
import { texts } from './text-second-step'

import { Fireworks } from '../../fireworks/Fireworks'
import { TLang } from 'src/constants/langs'
import styles from './styles.module.scss'

export type TSecondStepProps = {
    lang: TLang
}

export const SecondStep = ({ lang }: TSecondStepProps) => {
    const { content } = useLocalizedText(lang, texts)

    return (
        <>
            <div className={styles.container}>{content}</div>
            <Fireworks enabled={true} />
        </>
    )
}
